<template>
  <LogoDark v-if="$themeStore.isDark" />
  <LogoLight v-else />
</template>

<script lang="ts" setup>
import LogoLight from './LogoLight.vue';
import LogoDark from './LogoDark.vue';
import { useThemeStore } from '@/stores/theme.ts';

const $themeStore = useThemeStore();
</script>
